(function () {
  var MSG_ID = 'ice-cream-rule-msg';
  function valid(n) { return n === 0 || n % 55 === 0; }
  function text(n) {
    var base = 'Ice cream is sold in mixed-flavor orders in multiples of 55 cases: 55 cases $120/case, 110 cases (1 pallet) $90/case, 330+ cases (3 pallets) $70/case. Shipping included.';
    var cur = 'You have ' + n + ' ice cream cases in your cart. ';
    var r = n % 55;
    var fix = 'Add ' + (55 - r) + ' more cases to reach ' + (n - r + 55) + (n > 55 ? ', or remove ' + r + ' to order ' + (n - r) + '.' : '.');
    return { head: cur + fix, base: base };
  }
  function targets() {
    return Array.prototype.slice.call(document.querySelectorAll('#checkout, #CartDrawer-Checkout, button[name="checkout"], input[name="checkout"]'));
  }
  function extras() {
    return Array.prototype.slice.call(document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons'));
  }
  var obs;
  function watch() { obs.observe(document.body || document.documentElement, { childList: true, subtree: true }); }
  function apply(n) {
    obs.disconnect();
    var ok = valid(n);
    var btns = targets();
    btns.forEach(function (b) {
      if (!ok) { b.setAttribute('disabled', 'disabled'); b.setAttribute('aria-disabled', 'true'); b.style.opacity = '0.45'; b.style.pointerEvents = 'none'; }
      else { b.removeAttribute('disabled'); b.removeAttribute('aria-disabled'); b.style.opacity = ''; b.style.pointerEvents = ''; }
    });
    extras().forEach(function (e) { e.style.display = ok ? '' : 'none'; });
    var old = Array.prototype.slice.call(document.querySelectorAll('.' + MSG_ID));
    old.forEach(function (o) { o.parentNode && o.parentNode.removeChild(o); });
    if (n > 0 && btns.length) {
      var t = text(n);
      btns.forEach(function (b) {
        var host = b.parentNode;
        if (!host || host.querySelector('.' + MSG_ID)) return;
        var d = document.createElement('div');
        d.className = MSG_ID;
        d.style.cssText = 'margin:0 0 1rem;padding:1rem;border:1px solid ' + (ok ? '#2e7d32' : '#c62828') + ';border-radius:6px;font-size:1.3rem;line-height:1.5;text-align:left;';
        d.innerHTML = '<strong>' + (ok ? 'Ice cream order ready: ' + n + ' cases.' : t.head) + '</strong><br>' + t.base;
        host.insertBefore(d, b);
      });
    }
    watch();
  }
  var busy = false;
  function refresh() {
    if (busy) return; busy = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      var n = 0;
      (c.items || []).forEach(function (i) { if (i.sku && i.sku.indexOf('ICE-') === 0) n += i.quantity; });
      apply(n);
    }).catch(function () {}).then(function () { busy = false; });
  }
  var timer;
  function later() { clearTimeout(timer); timer = setTimeout(refresh, 350); }
  document.addEventListener('DOMContentLoaded', refresh);
  if (document.readyState !== 'loading') refresh();
  obs = new MutationObserver(later);
  watch();
})();